import React, { useRef } from "react";
import emailjs from "emailjs-com";
import "./MyContact.css";
import swal from "sweetalert";

const MyContact = () => {
   const form = useRef();
   const sendEmail = (e) => {
      e.preventDefault();

      emailjs
         .sendForm(
            "service_c6w00zu",
            "template_wz3jesm",
            form.current,
            "user_tNUclIy5e6ZlcXjNsL6tf"
         )
         .then(
            (result) => {
               swal("Good job!", "You clicked the button!", "success");
               console.log(result.text);
            },
            (error) => {
               console.log(error.text);
            }
         );
      e.target.reset();
   };
   return (
      <div
         style={{
            backgroundColor: "#212529",

            overflow: "hidden",
         }}
      >
         <div className="container " style={{ paddingTop: "100px" }}>
            <div
               className=" row "
               data-aos="fade-up"
               data-aos-easing="ease-in-sine"
               data-aos-duration="1000"
               data-aos-once="true"
            >
               <h1 className=" text-white ">Get In Touch</h1>
               <div
                  style={{
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
                     paddingTop: "6px",
                  }}
               >
                  <p className="border-style"></p>
               </div>
               <div className="col-lg-8 p-5  col-md-6 ">
                  <form ref={form} onSubmit={sendEmail}>
                     <div className="mb-3">
                        <label
                           for="exampleFormControlInput1"
                           classname="form-label"
                        >
                           <p
                              style={{ color: "#C0C0C0" }}
                              className=" fw-bold fs-5"
                           >
                              Name:
                           </p>
                        </label>
                        <input
                           type="text"
                           className="form-control p-2 bg-dark text-white"
                           id="exampleFormControlInput1"
                           placeholder="Name"
                           name="name"
                           required
                        />
                     </div>
                     <div className="mb-3">
                        <label
                           for="exampleFormControlInput1"
                           classname="form-label"
                        >
                           <p
                              style={{ color: "#C0C0C0" }}
                              className=" fw-bold fs-5"
                           >
                              {" "}
                              Email:
                           </p>
                        </label>
                        <input
                           type="email"
                           className="form-control p-2 text-white bg-dark"
                           id="exampleFormControlInput1"
                           placeholder="Your Email"
                           name="email"
                           required
                        />
                     </div>
                     <div className="mb-3">
                        <label
                           for="exampleFormControlInput1"
                           classname="form-label"
                        >
                           <p
                              style={{ color: "#C0C0C0" }}
                              className=" fw-bold fs-5"
                           >
                              {" "}
                              Phone:
                           </p>
                        </label>
                        <input
                           type="text"
                           className="form-control p-2 text-white bg-dark"
                           id="exampleFormControlInput1"
                           placeholder="Your Phone"
                           required
                           name="phone"
                        />
                     </div>
                     <div className="mb-3">
                        <label
                           for="exampleFormControlTextarea1"
                           className="form-label"
                        >
                           <p
                              style={{ color: "#C0C0C0" }}
                              className="fw-bold fs-5"
                           >
                              {" "}
                              Message:
                           </p>
                        </label>
                        <textarea
                           className="form-control text-white bg-dark"
                           id="exampleFormControlTextarea1"
                           rows="3"
                           name="message"
                           placeholder="wtite your message here"
                        ></textarea>
                        <br />
                        <input
                           type="submit"
                           value="Submit"
                           className="text-white pt-2 pb-2 rounded-3 btn btn-primary"
                           style={{ backgroundColor: "blue" }}
                           required
                        />
                     </div>
                  </form>
               </div>

               <div
                  className="col-lg-4 col-md-6"
                  style={{ paddingLeft: "100px", paddingTop: "70px" }}
               >
                  <h2 style={{ color: "#0d6efd" }}>Contact information</h2>
                  <div className="d-flex py-4">
                     <div>
                        <i
                           class="fas fa-phone me-3"
                           style={{ fontSize: "40px", color: "#0d6efd" }}
                        ></i>
                     </div>
                     <div>
                        <h2 style={{ color: "#C0C0C0" }}>Phone</h2>
                        <a
                           style={{ textDecoration: "none" }}
                           href="tel:+8801761489745"
                        >
                           {" "}
                           <p className="fw-bold" style={{ color: "#C0C0C0" }}>
                              +8801761489745
                           </p>
                        </a>
                     </div>
                  </div>
                  <div className="d-flex ">
                     <div>
                        <i
                           class="fas fas fa-map-marker-alt me-3"
                           style={{ fontSize: "40px", color: "#0d6efd" }}
                        ></i>
                     </div>
                     <div>
                        <h2 style={{ color: "#C0C0C0" }}>Address</h2>
                        <a
                           style={{ textDecoration: "none" }}
                           href="tel:+8801761489745"
                        >
                           {" "}
                           <p className="fw-bold" style={{ color: "#C0C0C0" }}>
                              Mohakhali, Dhaka-1212
                           </p>
                        </a>
                     </div>
                  </div>
                  <div className="d-flex py-4 me-2">
                     <div>
                        <i
                           class="fas fa-envelope me-3 "
                           style={{ fontSize: "40px", color: "#0d6efd" }}
                        ></i>
                     </div>
                     <div>
                        <h2 style={{ color: "#C0C0C0" }}>Email</h2>
                        <a
                           style={{ textDecoration: "none" }}
                           href="https://mail.google.com/mail/u/0/?fs=1&to=bakhtiar.abid2@gmail.com&tf=cm"
                        >
                           {" "}
                           <p
                              className="fw-bold "
                              style={{ color: "#C0C0C0", fontSize: "12px" }}
                           >
                              bakhtiar.abid2@gmail.com
                           </p>
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default MyContact;

{
   /* <div>
   <div className="d-flex">
      <i
         class="fas fa-phone me-3"
         style={{ fontSize: "40px", color: "#0d6efd" }}
      ></i>
      <div>
         <h2 style={{ color: "#C0C0C0" }}>Phone</h2>
         <a style={{ textDecoration: "none" }} href="tel:+8801761489745">
            {" "}
            <p className="fw-bold" style={{ color: "#C0C0C0" }}>
               +8801761489745
            </p>
         </a>
      </div>
   </div>
   <div className="d-flex">
      <i
         class="fas fas fa-map-marker-alt me-3"
         style={{ fontSize: "40px", color: "#0d6efd" }}
      ></i>
      <div>
         <h2 style={{ color: "#C0C0C0" }}>Address</h2>
         <a style={{ textDecoration: "none" }} href="tel:+8801761489745">
            {" "}
            <p className="fw-bold" style={{ color: "#C0C0C0" }}>
               Mohakhali , Dhaka-1212
            </p>
         </a>
      </div>
   </div>

   <div className="d-flex">
      <i
         class="fas fa-envelope me-3"
         style={{ fontSize: "40px", color: "#0d6efd" }}
      ></i>
      <div>
         <h2 style={{ color: "#C0C0C0" }}>Email</h2>
         <a
            style={{ textDecoration: "none" }}
            href="https://mail.google.com/mail/u/0/?fs=1&to=bakhtiar.abid2@gmail.com&tf=cm"
         >
            bakhtiar.abid2@gmail.com
         </a>
      </div>
   </div>
</div>; */
}
